/**
 * Sectorpilot Akıllı Görsel ve Menü Önbellek Yöneticisi (Local Agent + PWA IndexedDB)
 */

const DB_NAME = 'SectorpilotCacheDB';
const DB_VERSION = 1;
const STORE_NAME = 'offline_cache';

const getDB = () => {
  return new Promise((resolve, reject) => {
    if (!window.indexedDB) {
      return reject(new Error('IndexedDB not supported'));
    }
    const request = window.indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'key' });
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
};

export const getIndexedDBCache = async (key) => {
  try {
    const db = await getDB();
    return new Promise((resolve) => {
      const tx = db.transaction(STORE_NAME, 'readonly');
      const store = tx.objectStore(STORE_NAME);
      const req = store.get(key);
      req.onsuccess = () => resolve(req.result ? req.result.value : null);
      req.onerror = () => resolve(null);
    });
  } catch (err) {
    return null;
  }
};

export const setIndexedDBCache = async (key, value) => {
  try {
    const db = await getDB();
    return new Promise((resolve) => {
      const tx = db.transaction(STORE_NAME, 'readwrite');
      const store = tx.objectStore(STORE_NAME);
      store.put({ key, value, timestamp: Date.now() });
      tx.oncomplete = () => resolve(true);
      tx.onerror = () => resolve(false);
    });
  } catch (err) {
    return false;
  }
};

export const getOptimizedImageUrl = (url) => {
  if (!url || typeof url !== 'string') return url;
  if (url.startsWith('data:') || url.startsWith('blob:') || url.endsWith('.svg')) return url;
  
  const customHost = typeof window !== 'undefined' ? localStorage.getItem('sectorpilot_cash_register_ip') : null;
  const isLocal = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
  
  if (customHost && customHost.trim()) {
    const cleanHost = customHost.trim().replace(/^https?:\/\//, '').replace(/\/+$/, '');
    return `http://${cleanHost}:4005/cache/images?url=` + encodeURIComponent(url);
  }
  
  if (isLocal) {
    return 'http://localhost:4005/cache/images?url=' + encodeURIComponent(url);
  }
  return url;
};
